import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;

export const fmt = {
  currency: (n) => {
    const num = Number(n || 0);
    const parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$ ' + parts.join('.');
  },
  number: (n, dec=0) => {
    const num = Number(n || 0);
    const parts = num.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  date: (d) => {
    if (!d) return '-';
    // إضافة Z لأن SQLite يحفظ بدونها — المتصفح يتعامل معه كـ UTC+3 (تركيا)
    const str = String(d).includes('Z') || String(d).includes('+') ? d : d + 'Z';
    const dt = new Date(str);
    const day   = String(dt.getDate()).padStart(2,'0');
    const month = String(dt.getMonth()+1).padStart(2,'0');
    const year  = dt.getFullYear();
    return `${day}/${month}/${year}`;
  },
  datetime: (d) => {
    if (!d) return '-';
    const str = String(d).includes('Z') || String(d).includes('+') ? d : d + 'Z';
    const dt = new Date(str);
    const day   = String(dt.getDate()).padStart(2,'0');
    const month = String(dt.getMonth()+1).padStart(2,'0');
    const year  = dt.getFullYear();
    const hr    = String(dt.getHours()).padStart(2,'0');
    const min   = String(dt.getMinutes()).padStart(2,'0');
    return `${day}/${month}/${year} ${hr}:${min}`;
  },
};

export const ROLES = {
  admin: 'مدير النظام',
  sales_manager: 'مدير مبيعات',
  sales_employee: 'موظف مبيعات',
  warehouse: 'أمين مستودع',
  production_manager: 'مدير إنتاج',
};

export const PAYMENT_TYPES = { cash: 'نقدي', credit: 'آجل', installment: 'تقسيط', check: 'شيك' };
export const ORDER_STATUS = { pending: 'معلق', confirmed: 'مؤكد', delivered: 'مسلّم', cancelled: 'ملغي' };
export const PROD_STATUS = { pending: 'بانتظار الإنتاج', in_progress: 'قيد التنفيذ', ready: 'جاهز للتسليم', delivered: 'تم التسليم' };
export const CUSTOMER_STATUS = { active: 'نشط', idle: 'خامل', stopped: 'متوقف' };
export const SOURCES = ['مباشر', 'إحالة', 'سوشيال ميديا', 'معرض', 'موقع إلكتروني', 'إعلان', 'أخرى'];
export const PRIORITY = { low: 'منخفض', normal: 'عادي', high: 'عالي' };

export const canAccess = (user, roles) => roles.includes(user?.role);

export const exportFile = async (type) => {
  const token = localStorage.getItem('token');
  const res = await fetch(`/api/export/${type}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('فشل التصدير');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `${type}_${new Date().toISOString().split('T')[0]}.xlsx`; a.click();
  URL.revokeObjectURL(url);
};
